<template>
  <div
    class="p-1 rounded-lg text-sm flex flex-wrap items-start gap-3 cursor-pointer w-full"
  >
    <div class="flex flex-col">
      <p class="text-sm">
        {{ useDateFormat(note.created, 'HH:MMa MMM D, YYYY') }}
      </p>

      <Paragraph
        :data="note.message"
        class=" flex-1 text-left mt-6 htmldescription"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { MNotification } from '~/types/index'
const note = defineProps<MNotification>()
const { toggleRead } = useNotification()
</script>

<style scoped>

</style>
